import React, { ReactNode } from 'react';
import Box from '../Box/Box';

type THubControlBodyProps = {
  children: ReactNode;
};

const HubControlBody = ({ ...rest }: THubControlBodyProps) => (
  <Box {...rest} parent="HubControl" name="body" as="div" />
);

export default HubControlBody;
